module.exports = __webpack_public_path__ + "img/m2.114fc01e.png";